import {
  Heading,
  HStack,
  Input,
  Stack,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  useColorModeValue,
  VStack,
  Image,
  FormControl,
  FormLabel,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import UploadSvg from '../assets/upload.svg'

const CountMyNFT = () => {
  const [traitCount, setTraitCount] = useState<string>('8,7,6')
  const [possibilties, setPossibilties] = useState({ total: 1, optimal: 1 })

  useEffect(() => {
    let traits: Array<any> = traitCount?.split(',')
    traits = traits.map((trt) => Number(trt.trim()))
    let totalPossible = traits.reduce((count: number, trt: number) => (count = count * trt), 1)
    let roundOffValue = totalPossible > 1500 ? 100 : 10
    let multiplier = totalPossible > 1500 ? 0.8 : 0.9
    let optimalPossible =
      traits.length > 1 && totalPossible > 10
        ? Math.floor((totalPossible * multiplier) / roundOffValue) * roundOffValue
        : 0
    setPossibilties({ total: totalPossible, optimal: optimalPossible })
  }, [traitCount])

  return (
    <VStack
      spacing={{ base: '30px' }}
      minH={{ base: '80vh', md: '70vh' }}
      wrap={'wrap'}
      align={'center'}
      justify={'center'}
      mb={'10px'}
    >
      <HStack
        minH={{ base: '80vh', md: '70vh' }}
        wrap={'wrap'}
        align={'center'}
        justify={'center'}
        my={'10px'}
      >
        <Image src={UploadSvg} boxSize={{ base: '220px', md: 'md' }}></Image>
        <Stack
          spacing={8}
          bg={useColorModeValue('white', 'gray.700')}
          rounded={'xl'}
          boxShadow={'lg'}
          p={{ base: '6', md: '12' }}
          my={{ base: '12', md: '12' }}
          maxW={'sm'}
        >
          <Heading
            fontSize={{ base: '2xl', md: '4xl' }}
            color={'brand.500'}
            alignSelf={'center'}
            lineHeight={0.8}
          >
            Count My NFTs
          </Heading>
          <Text alignSelf={'center'} textAlign={'center'}>
            Possible and Optimal NFTs to generate from your kitty of traits
          </Text>
          <FormControl id="trait">
            <FormLabel>Trait Count</FormLabel>
            <Text fontSize={'xs'}>enter individual trait count as comma seperated values </Text>
            <Input
              placeholder="10,10,10"
              _placeholder={{ color: 'gray.500' }}
              type="text"
              value={traitCount}
              onChange={(e: any) => setTraitCount(e.target.value)}
            />
          </FormControl>

          <Stack spacing={6}>
            <Stat>
              <StatLabel>Possible NFT Combinations</StatLabel>
              <StatNumber mb={'5px'}>{possibilties.total}</StatNumber>
            </Stat>
            {possibilties.optimal && (
              <Stat>
                <StatLabel>Optimal Combinations</StatLabel>
                <StatNumber mb={'5px'}>
                  {possibilties.optimal}{' '}
                  <Text fontSize={'md'} display={'inline'}>
                    or less
                  </Text>
                </StatNumber>
              </Stat>
            )}
          </Stack>
        </Stack>
      </HStack>
    </VStack>
  )
}

export default CountMyNFT
